import { render, staticRenderFns } from "./PayrollRecords.vue?vue&type=template&id=1dcd51b0&scoped=true&"
import script from "./PayrollRecords.vue?vue&type=script&lang=js&"
export * from "./PayrollRecords.vue?vue&type=script&lang=js&"
import style0 from "./PayrollRecords.vue?vue&type=style&index=0&id=1dcd51b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcd51b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSelect,VSimpleTable})
